import Vue from 'vue'
import App from '@/App.vue'
import VueRouter from 'vue-router'
import store from '@/store';
import router from './router/routerConfig.js'
import '@/api';
//引入elemtnt
import ElementUI from 'element-ui';
import '@/theme/index.css'
import VueResource from 'vue-resource'
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);
// import './assets/icon/iconfont.css '
import '@/assets/icon/iconfont.js'
import 'lib-flexible/flexible'
import * as echarts from 'echarts'
import * as filters from '@/assets/js/filters' // global filters
import * as constants from '@/config/constants'
import * as directives from "@/assets/js/directive"; // 防重复点击
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// use
Vue.use(mavonEditor)
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]) // 插入过滤器名和对应方法
})

Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})
import Print from 'vue-print-nb'
Vue.use(Print);


Vue.use(VueResource)

Vue.use(VueRouter)
Vue.use(ElementUI)

import Probability from '@/components/TableColumn/Probability.vue'
Vue.component(Probability.name, Probability);

import ProbabilityTea from '@/components/TableColumn/ProbabilityTea.vue'
Vue.component(ProbabilityTea.name, ProbabilityTea);

Vue.prototype.$echarts = echarts
Vue.prototype.$constants = constants

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	const app = document.querySelector('.app-main')
  app && app.scrollTo({ top: 0, left: 0 })
	if (to.meta.title!= 'school') {
    document.title = "门道学业规划平台"
  }
  let hasToken = sessionStorage.getItem('satoken');
  if (!hasToken) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      ElementUI.Message.error('请先登录...');
      next({
        path: '/',
      })
    } else {
      next()
    }
  } else {
    if (to.matched.some(record => record.meta.gaokaoLimit)) {
      if(store.getters.userInfo.disableFunction){
        // ElementUI.Message.error('“院校查询”、“定位专业”、“方案设计”模块6-8月份非高三用户不可使用');
        ElementUI.Message.error({
          message: '“院校查询”、“定位专业”、“方案设计”模块6-8月份非高三用户不可使用',
          duration: 0, // 显示时长，单位毫秒，设为0则不会自动关闭
          showClose: true, // 是否显示关闭按钮
          onClose: () => {
            // 这里写关闭时的回调逻辑
            console.log('消息已关闭');
          }
        });
        next({
          path: '/policy/index',
        })
      }
    }

    if (store.getters.userInfo && store.getters.permissionNavbarRoutes.length === 0) {
      store.dispatch('GenerateRoutes').then((data) => {
        router.addRoutes(data)          // 动态添加可访问路由表
        next({ ...to, replace: true })  // hack方法 确保addRoutes已完成
      })
    } else {
      next()
    }
  }
})

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App),
  created() {
    document.addEventListener('copy', this.handleCopy);
  },
  beforeDestroy() {
    document.removeEventListener('copy', this.handleCopy);
  },
  methods: {
    handleCopy(event) {
      if (this.$route.path !== '/aiQA') {
        event.preventDefault();
      }
    }
  }
})
